import {eventTimeObject, eventTitle} from '@/league/components/EventCards/eventMethods';
import {ALL_CLIPS, EVENT_AUTO_CLIPS} from '@/store/getterTypes';

export const extendClipData = (clip) => {
  let clipEventTitle = '';
  let clipEventDate = '';
  let downloadName;
  if (clip.event) {
    const event = clip.event;
    const time = eventTimeObject(event);
    
    clipEventTitle = eventTitle(event);
    clipEventDate = `${time.month} ${time.day} ${time.hh}`;
    downloadName = `${clipEventTitle} ${clipEventDate}`;
  } else {
    downloadName = clip.name;
  }

  
  const [hSt, mSt, sSt] = clip.start_time.split(':').map(Number);
  const [hD, mD, sD] = clip.duration.split(':').map(Number);
  const endTime = new Date();
  endTime.setHours(hSt + hD, mSt + mD, sSt + sD, 0);
  const h = String(endTime.getHours()).padStart(2, '0');
  const m = String(endTime.getMinutes()).padStart(2, '0');
  const s = String(endTime.getSeconds()).padStart(2, '0');
  const end = `${h}:${m}:${s}`;
  const clipTimes = {start: clip.start_time, end};
  
  const tagsList = `#${clip.tags.join(', #')}`;
  downloadName = `${downloadName} - ${tagsList} (${clipTimes.start} - ${clipTimes.end})`;
  
  const searchString = [
    clipEventTitle, clipEventDate, clipTimes.start, clipTimes.end, tagsList, clip.name,
  ].join(' ').toLowerCase();
  
  return {
    ...clip,
    clipEventTitle,
    clipEventDate,
    downloadName,
    clipTimes,
    tagsList,
    searchString,
  };
};

export default {
  [ALL_CLIPS]: (state) => {
    const allClips = state.allClips || [];
    if (allClips.length) {
      return allClips.map(extendClipData);
    }
    return [];
  },
  [EVENT_AUTO_CLIPS]: ({autoClips}) => {
    return [...autoClips].map((item) => {
      const clip = extendClipData(item);
      return {
        ...clip,
        tagsList: item.tags.join(', '),
        original_id: item.id,
      };
    });
  },
};
